import Entity from "../../core/entity/Entity";

/**
 * Interface for entities that can damage the shield when they collide with it
 */
export interface ShieldDamager extends Entity {
  /**
   * Amount of damage this entity deals to the shield
   */
  getShieldDamage(): number;

  /**
   * Called when this entity hits the shield
   * The entity can implement custom behavior (e.g., explode, die, etc.)
   */
  onShieldHit(): void;
}

/**
 * Type guard to check if an entity implements ShieldDamager
 */
export function isShieldDamager(entity: unknown): entity is ShieldDamager {
  return (
    typeof (entity as any).getShieldDamage === "function" &&
    typeof (entity as any).onShieldHit === "function"
  );
}
